import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconUploadBold = props => (
  <SvgIcon {...props} viewBox="0 0 14 17">
    <path d="m14 11h-4v6h-6v-6h-4l7-7 7 7zm-14-9v-2l14 0.000001v2h-14z" />
  </SvgIcon>
);

export default IconUploadBold;



// WEBPACK FOOTER //
// ./src/components/icons/IconUploadBold.js